// extracted by mini-css-extract-plugin
module.exports = {"footer":"_5D3v6Qwm","cancel":"_5D1-_uvt","button":"_5DFS2YFL"};